import React, { useState, useCallback } from 'react'
import { I18n } from '@front/volcanion'

import { Box, Tab, Tabs } from '@mui/material'

import TabPanel from './Table'
import SearchForm from './Form'

const StaffHistory = () => {
  const [tab, setTab] = useState(0)
  const onTabChange = useCallback((e, v) => setTab(v), [])
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', p: 3, gap: 2 }}>
      <SearchForm />
      <Tabs value={tab} onChange={onTabChange}>
        <Tab label={I18n.t('event.label', { count: 2 })} />
        <Tab label={I18n.t('action.label', { count: 2 })} />
      </Tabs>
      <TabPanel hide={tab !== 0} model_name='event' />
      <TabPanel hide={tab !== 1} model_name='action' />
    </Box>
  )
}

export default React.memo(StaffHistory)
